var render = function render(){var _vm=this,_c=_vm._self._c;return _c('layout-default-appbar',{attrs:{"back-to":_vm.rotaabastecimento}},[_vm._v(" Histórico Abastecimento ")])
}
var staticRenderFns = []

export { render, staticRenderFns }